import { store } from '@/store'
import {  NavigationGuardNext } from 'vue-router'

/**
 * Registration route can be visited if the authenticated user does NOT exist,
 * or, the authenticated user has ZERO tenant memberships
 */
export default (to, from, next: NavigationGuardNext) => {
    //  Create a 'pass' function
    const pass = () => {
        store.getters.appDebug && console.log(`GUARD: registration-guard pass...`)
        return next()
    }

    //  Create a 'fail' function
    const fail = () => {
        store.getters.appDebug && console.log(`GUARD: registration-guard stop.`)
        return next('/memberships')
    }

    //  Fetch the currently authenticated user
    const user = store.getters.user

    //  If the user does NOT exist, guard passes
    if (!user) return pass()

    //  If user's membership count is greater than zero, guard fails!
    if (user.memberships.length > 0) return fail()

    //  Else, the authenticated user has no memberships, so guard passes
    return pass()
}
